import React from "react";
import "./calendar.css";
import useWeekCalendar from "../../hooks/calendar/useWeekCalendar";
const addOverlapColumns = (appointments, unavailables) => {
  const events = [
    ...appointments.map((appointment) => ({
      ...appointment,
      type: "appointment",
    })),

    ...unavailables.map((unavailable) => ({
      ...unavailable,
      type: "unavailable",
    })),
  ];

  const sorted = [...events].sort((a, b) =>
    a.startTime.localeCompare(b.startTime),
  );

  const groups = [];
  const result = [];

  sorted.forEach((event) => {
    let group = groups.find((g) =>
      g.some(
        (item) =>
          event.startTime < item.endTime && event.endTime > item.startTime,
      ),
    );

    if (!group) {
      group = [];
      groups.push(group);
    }

    group.push(event);
  });

  groups.forEach((group) => {
    const totalColumns = group.length > 1 ? group.length : 1;
    group.forEach((event, index) => {
      result.push({
        ...event,
        column: index,
        totalColumns,
      });
    });
  });
  return result;
};
const WeekView = ({
  date,
  appointments = [],
  employeeColors = [],
  unavailableEmployees = [],
  showModalShortcut,
}) => {
  const { days, timeSlots, getTop, getHeight, sameDay, isToday } =
    useWeekCalendar(date);
  const getEmployeeColor = (name) => {
    return (
      employeeColors.find((item) => item.name === name)?.color || "#849b8c"
    );
  };
  return (
    <div className="week-calendar">
      <div className="week-header">
        <div className="time-header"></div>

        {days.map((day) => (
          <div key={day} className="day-header">
            {day.toLocaleDateString("en-US", {
              weekday: "short",
              day: "numeric",
            })}
          </div>
        ))}
      </div>

      <div className="week-body">
        <div className="time-column">
          {timeSlots.map((slot) => (
            <div key={slot} className="time-slot">
              {slot}
            </div>
          ))}
        </div>

        {days.map((day) => (
          <div key={day} className="week-day-column">
            {timeSlots.map((slot) => (
              <div
                key={slot}
                onClick={(e) => {
                  showModalShortcut(day, slot);
                }}
                className={`schedule-slot ${isToday(day) ? "today" : ""}`}
              />
            ))}

            {addOverlapColumns(
              appointments.filter((app) => sameDay(new Date(app.date), day)),
              unavailableEmployees.filter((item) =>
                sameDay(new Date(item.date), day),
              ),
            ).map((event) => {
              if (event.type == "appointment") {
                return (
                  <>
                    <div
                      key={event.id}
                      className="appointment"
                      style={{
                        top: getTop(event.startTime),
                        height: getHeight(event.startTime, event.endTime),
                        left: `${(event.column * 100) / event.totalColumns}%`,
                        width: `${100 / event.totalColumns - 1}%`,
                        backgroundColor: getEmployeeColor(event.staffName),
                      }}
                    >
                      <strong>
                        {event.client} ·{" "}
                        {event.services
                          .map((service) => service.name)
                          .join(", ")}
                      </strong>
                      <br></br>
                      <small>{event.staffName}</small>
                      <div className="appointment-tooltip">
                        <div>
                          <strong>{event.client}</strong>
                        </div>
                        <div>Time: {event.startTime.slice(0, 5)}</div>
                        <div>Staff: {event.staffName}</div>
                      </div>
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    <div
                      key={event.id}
                      className="unavailable-event"
                      style={{
                        top: getTop(event.startTime),
                        height: getHeight(event.startTime, event.endTime),
                        left: `${(event.column * 100) / event.totalColumns}%`,
                        width: `${100 / event.totalColumns - 1}%`,
                        backgroundColor: "lightblue",
                      }}
                    >
                      <strong>{event.barber} -unavailable</strong>
                      <br></br>
                      <small>{event.barber}</small>
                      <div className="appointment-tooltip">
                        <div>
                          <strong>{event.barber}</strong>
                        </div>
                        <div>
                          Time: {event.startTime.slice(0, 5)} -{" "}
                          {event.endTime.slice(0, 5)}
                        </div>
                        <div>Reason: {event.reason}</div>
                      </div>
                    </div>
                  </>
                );
              }
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeekView;
